<template>
  <div
    class="asc-analyticswatchlist-grid-wrapper--container"
    data-automation-id="wrapper_analytic_watchlist_grid"
  >
    <asc-container>
      <template slot="header">
        <asc-grid-wrapper-header :title="title">
          <asc-grid-date-picker-button
            :filter-start-date="filterStartDate"
            :filter-end-date="filterEndDate"
            :day-selected="daySelected"
            :on-date-change="onDateChange"
          ></asc-grid-date-picker-button>
        </asc-grid-wrapper-header>
      </template>
      <asc-analytic-watchlist-grid
        :values="values"
        :on-open="onOpen"
        :grid-filters="gridFilters"
        export-button-visible
      ></asc-analytic-watchlist-grid>
    </asc-container>
  </div>
</template>

<script>
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import AscContainer from '@/components/atoms/AscContainer'
import AscGridDatePickerButton from '@/components/molecules/AscGridDatePickerButton'
import AscAnalyticWatchlistGrid from '@/components/molecules/AscAnalyticWatchlistGrid'
import AscGridWrapperHeader from '@/components/molecules/AscGridWrapperHeader'

export default {
  name: 'AscAnalyticWatchlistGridWrapper',

  components: {
    AscAnalyticWatchlistGrid,
    AscContainer,
    AscGridDatePickerButton,
    AscGridWrapperHeader,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  data() {
    return {
      selectedItems: [],
    }
  },

  computed: {
    isExportButtonDisplayed() {
      return true
    },
  },
}
</script>
